import React from 'react';
import {_t} from "../../../../js/app/common/utils/locale";

export default class InfoCardAuthenticator extends React.Component {

    render() {
        return (
            <div className="info-card info-card__greeting">
                <h4 className="title title--h4 info-card__title has-subtitle">
                    {_t('Please, enter the security code')}
                </h4>
                <p className="p info-card__subtitle">{_t('from the Google Authenticator APP')}</p>
                <picture className="info-card__picture">
                    <img src="/v2/images/cluster/authentificator.svg" alt={_t('Google Authenticator')}/>
                </picture>
            </div>
        );
    }

}